import { AnaColumn } from "../forms-template.service";

export const renEsportazioniMovimenti: AnaColumn[] = [
  {
    itemType: "group", colCount: "2", colSpan: "2", data: [
      {
        type: 'campoData',
        dataField: "dataRegistrazione",
        dataType: "datetime",
        caption: "Data Registrazione",
        colAlignment: 'center',
        class: 'text-center',
        horizontalAlignment: 'center',
        format: 'dd/MM/yyyy',
        colWidth: '150',
        colVisible: true,
      },
      {
        type: 'campo',
        dataField: "protocollo",
        dataType: "",
        caption: "N. Protocollo",
        class: 'text-center',
        horizontalAlignment: 'center',
        colAlignment: 'center',
        colWidth: '100',
        colVisible: true,
      },
      {
        type: 'campo',
        dataField: "idRentri",
        dataType: "",
        caption: "Id Rentri",
        class: 'text-center',
        horizontalAlignment: 'center',
        colAlignment: 'left',
        colWidth: '200',
        colVisible: true,
      },

      {
        type: 'campo',
        dataField: "annoRettifica",
        dataType: "",
        caption: "Anno Rettifica",
        colAlignment: 'end',
        class: 'text-end',
        horizontalAlignment: 'end',
        colWidth: '100',
        colVisible: true,
      },

      {
        type: 'campo',
        dataField: "numeroRettifica",
        dataType: "",
        caption: "N. Rettifica",
        colAlignment: 'end',
        class: 'text-end',
        horizontalAlignment: 'end',
        colWidth: '100',
        colVisible: true,
      },
      {
        type: 'campo',
        dataField: "causale",
        dataType: "",
        caption: "Causale",
        colWidth: '70',
        colVisible: true,
      },
      {
        type: 'campo',
        dataField: "numeroFormulario",
        dataType: "",
        caption: "N. Formulario",
        class: 'text-center',
        horizontalAlignment: 'center',
        colWidth: '160',
        colVisible: true,
      },
      {
        type: 'campo',
        dataField: "eer",
        dataType: "",
        colAlignment: 'center',
        caption: "EER",
        colWidth: '80',
        colVisible: true,
      },
      {
        type: 'campo',
        dataField: "statoFisico_Descrizione",
        dataType: "",
        caption: "Stato Fisico",
        colWidth: '100',
        colVisible: true,
      },
      {
        type: 'campo',
        dataField: "idOperazioneRD",
        dataType: "",
        caption: "Recupero",
        colWidth: '100',
        colVisible: true,
      },
      {
        type: 'campo',
        dataField: "quantitaOrigineKg",
        dataType: "",
        caption: "Quantita",
        colAlignment: 'end',
        class: 'text-end',
        horizontalAlignment: 'end',
        colWidth: '70',
        colVisible: true,
      },
      {
        type: 'campo',
        dataField: "annotazioni",
        dataType: "",
        caption: "Annotazioni",
        colWidth: '100',
        colVisible: true,
      },
    ]
  }]



export const renEsportazioni: AnaColumn[] = [
  {
    itemType: "group", colCount: "2", colSpan: "2", class: 'bg-danger', data: [
      {
        type: 'buttonArray',
        dataField: "buttonArray",
        colVisible: true,
        dataType: "",
        hideOnEdit: true,
        colWidth: '40px',
        class: 'text-center ',
        horizontalAlignment: 'center',
        showEditorAlways: true,
        buttonArray: [{

          name: 'downloadPacchetto',
          hint: 'Download XML',
          icon: 'bi bi-filetype-xml',    // devextreme: 'search',
          text: 'Download XML',
          type: 'text',
          class: '',
          event: 'downlodXML'
        },
        {
          name: 'anteprimaAllegato',
          hint: 'Stampa Registro',
          icon: 'export icon-file-pdf',    // devextreme: 'search',
          text: 'Stampa Registro',
          type: 'text',
          class: 'exportBlk',
          event: 'anteprimaAllegato'
        },
        {
          name: "dettagliMovimenti",
          hint: "Visualizza Movimenti",
          icon: "bi bi-info-square",
          text: "Visualizza Movimenti",
          type: 'button',
          class: '',
          event: "dettagliMovimenti",
        }
        ]

      },
      {
        type: 'campo',
        dataField: "anno",
        colVisible: true,
        dataType: "",
        caption: "Anno",
        colWidth: '50',
        colAlignment: 'center',
        visibleIndex: 1
      },
      {
        type: 'campoData',
        dataField: "dataesportazione",
        dataType: "datetime",
        caption: "Data Esportazione",
        format: 'dd/MM/yyyy',
        colVisible: false,
        colWidth: '130',
        visibleIndex: 2,
        colAlignment: 'center'
      },
      {
        type: 'campoData',
        dataField: "datainizio",
        dataType: "date",
        caption: "Dt. Iniziale Mov.",
        format: 'dd/MM/yyyy',
        colWidth: '130',
        visibleIndex: 3,
        colAlignment: 'center'
      },
      {
        type: 'campoData',
        dataField: "datafine",
        dataType: "date",
        caption: "Dt. Finale Mov.",
        format: 'dd/MM/yyyy',
        colWidth: '130',
        visibleIndex: 4,
        colAlignment: 'center'

      },
      {
        type: 'campo',
        dataField: "codicefiscaleazienda",
        colVisible: false,
        dataType: "",
        caption: "Codice Fiscale",
        colWidth: '100'
      },
      {
        type: 'campo',
        dataField: "idsitorentri",
        colVisible: false,
        dataType: "",
        caption: "Sito Rentri",
        colWidth: '100'
      },
      /*{
        type: 'campo', dataField: "idsitorentri", dataType: "string", 
        caption: "Sito Rentri",               
        lista: {
          dataSource: 'RenEsportazioni/GetElencoSedi',
          displayExpr: 'descrizione',
          valueExpr: 'id',
          static: false,
          related:['idregistrorentri']
        }
      },*/
      {
        type: 'campo',
        dataField: "descrizionesitorentri",
        colVisible: true,
        dataType: "",
        caption: "Unità Locale",
        colWidth: '300'
      },
      /*
       queryString: '?TipoOperazione=$idTipoOperazione',
                cascading: ['id|trasporto'],
      */
      /* {
         type: 'campo', 
         dataField: "idregistrorentri", 
         colVisible: false,
         dataType: "",
         caption: "Reg. Rentri", 
         colWidth:'100',
         
         lookup: {
           wingap:true,
           dataSource: 'RenEsportazioni/GetElencoRegistriByIdSedeRegistroRentri',
           displayExpr: 'descrizione',
           valueExpr: 'id',
           static: false,
           queryString: '?idSedeRentri=0',
         }
       },*/
      {
        type: 'campo',
        dataField: "idregistrorentri",
        colVisible: true,
        dataType: "",
        caption: "ID Registro",
        colWidth: '130'
      },
      {
        type: 'campo',
        dataField: "descrizioneregistro",
        colVisible: true,
        dataType: "",
        caption: "Descrizione Registro",
        colWidth: '300'
      },
      {
        type: 'campo',
        dataField: "protocolloinizio",
        colVisible: true,
        dataType: "",
        caption: "Da Protocollo",
        colWidth: '100',
        colAlignment: 'right'
      },
      {
        type: 'campo',
        dataField: "protocollofine",
        colVisible: true,
        dataType: "",
        caption: "A Protocollo",
        colWidth: '100',
        colAlignment: 'right'
      },
      {
        type: 'campo',
        dataField: "numeroregistrazioni",
        colVisible: true,
        dataType: "",
        caption: "N. Reg.",
        colWidth: '100',
        colAlignment: 'right'
      },

      {
        type: 'campo',
        dataField: "nomefilexml",
        colVisible: false,
        dataType: "",
        caption: "",
        colWidth: '100'
      },
      {
        type: 'campo',
        dataField: "documento",
        colVisible: false,
        dataType: "",
        caption: "",
        colWidth: '100'
      },
      {
        type: 'campo',
        dataField: "altreinfo",
        colVisible: true,
        dataType: "",
        caption: "Note",
        colWidth: '100'
      },
      /*{
      RenEsportazioni/GetElencoSedi
        type: 'campo', dataField: "siglaProvincia", dataType: "string", caption: "PROVINCIA",
        
        validation: [{ type: "required", message: "Campo Obbligatorio" }],
        lista: {
          dataSource: 'provincia',
          displayExpr: 'siglaProvincia',
          valueExpr: 'siglaProvincia',
          static: false
        }
      },*/

    ]
  },
]

export const serviceRentriSede: AnaColumn[] = [


  {
    itemType: "group", caption: 'Sede RENTRi', class: '', colCount: "1", data: [

      {
        type: 'campo',
        dataField: "num_iscr_sito",
        colVisible: true, dataType: "",
        caption: "Codice R.E.N.T.R.i",
        hideOnEdit: true,
        colWidth: '200'

      },
      {
        type: 'campo', dataField: "nome",
        colVisible: true, dataType: "",
        caption: "Nome",
        hideOnEdit: true,
        colWidth: '300'
      },
      {
        type: 'campo',
        dataField: "indirizzo",
        colVisible: true,
        dataType: "",
        caption: "Indirizzo",
        colWidth: '200'

      },
      {
        type: 'campo',
        dataField: "civico",
        colVisible: true,
        dataType: "",
        colWidth: '70',
        caption: "Civico",
        hideOnEdit: true,

      },
      {
        type: 'campo',
        dataField: "comune",
        colVisible: false,
        dataType: "",
        caption: "Comune",
        hideOnEdit: true,
        colWidth: '94'
      },
      {
        type: 'provincia',
        dataField: "comune",
        colVisible: false,
        dataType: "",
        caption: "Provincia",
        hideOnEdit: true,
        colWidth: '143px'
      },
      {
        type: 'campoData',
        dataField: "dataCreazione",
        colVisible: false,
        dataType: "datetime",
        caption: "Data creazione",
        hideOnEdit: true,
        format: 'dd/MM/yyyy',
        colWidth: '88',

      },
    ]

  }]